// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__rpc9L","rootCenter":"LoadMoreObserver_rootCenter__1TRwI","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2ZXU0"};